import React from 'react';
import { SearchHit } from '@/types/search';
import Hit from '@/components/Search/Hit';
interface HitsProps {
  items: SearchHit[];
}
const Hits: React.FC<HitsProps> = ({
  items
}) => {
  const sort = (a: SearchHit, b: SearchHit) => {
    if (a.title < b.title) {
      return -1;
    } else if (a.title > b.title) {
      return 1;
    } else {
      return 0;
    }
  };
  return <>
      <div className="overflow-scroll">
        {items.sort(sort).map((hit: SearchHit, index: React.Key | null | undefined) => {
        return <Hit key={index} {...hit} />;
      })}
      </div>
    </>;
};
export default Hits;